import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import { FaClipboardList, FaSpinner, FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import './TakeOrder.css';

const TakeOrder = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Préparation de la commande...');
  const [step, setStep] = useState(1);

  React.useEffect(() => {
    try {
      const user = auth.currentUser;
      console.log('Current user:', user);

      if (user) {
        const userInfo = {
          prenom: user.email.split('@')[0],
          table: '0',
          email: user.email,
          idclient: Math.floor(1000 + Math.random() * 9000)
        };

        localStorage.setItem('userInfo', JSON.stringify(userInfo));

        // Animation des étapes
        setTimeout(() => {
          setStep(2);
          setMessage('Redirection vers le menu...');
        }, 1000);

        setTimeout(() => {
          navigate('/menu');
        }, 2500);
      } else {
        console.error('Aucun utilisateur connecté');
        navigate('/login');
      }
    } catch (error) {
      console.error('Erreur lors de la redirection:', error);
    }
  }, [navigate]);

  return (
    <div className="take-order-container">
      <div className="take-order-card">
        <div className="take-order-header">
          <div className="take-order-icon">
            <FaClipboardList />
          </div>
          <h1 className="take-order-title">Prise de Commande</h1>
        </div>
        
        <div className="take-order-content">
          <div className="take-order-message-container">
            <div className="take-order-message-icon">
              {step === 1 ? (
                <FaSpinner className="take-order-spinner" />
              ) : (
                <FaCheckCircle className="take-order-success-icon" />
              )}
            </div>
            <p className="take-order-message">{message}</p>
          </div>
          
          <div className="take-order-progress">
            <div className="take-order-progress-bar">
              <div className={`take-order-progress-fill ${step === 2 ? 'take-order-progress-complete' : ''}`}></div>
            </div>
            <div className="take-order-steps">
              <div className={`take-order-step ${step >= 1 ? 'take-order-step-active' : ''}`}>
                <span className="take-order-step-number">1</span>
                <span className="take-order-step-text">Préparation</span>
              </div>
              <div className="take-order-step-divider">
                <FaArrowRight />
              </div>
              <div className={`take-order-step ${step >= 2 ? 'take-order-step-active' : ''}`}>
                <span className="take-order-step-number">2</span>
                <span className="take-order-step-text">Redirection</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TakeOrder; 